import { z } from "zod"
import { formatLocalIsoDate } from "@/shared/utils/time"

export const TODAY_ISO = formatLocalIsoDate(new Date())

export const childFormSchema = z.object({
  name: z.string().trim().min(1, "Ange ett namn"),
  birthDate: z
    .string()
    .min(1, "Välj ett datum")
    .refine((value) => value <= TODAY_ISO, "Datumet kan inte vara i framtiden"),
  sex: z.enum(["boy", "girl"]),
})

export type ChildFormInput = z.input<typeof childFormSchema>
export type ChildFormValues = z.output<typeof childFormSchema>

// Uppercase + trim so users can paste loosely.
export const redeemSchema = z.object({
  code: z.string().trim().toUpperCase().length(6, "Koden är 6 tecken"),
})

export type RedeemInput = z.input<typeof redeemSchema>
export type RedeemValues = z.output<typeof redeemSchema>
